import { LeaveBalanceSnapshot } from '../../types/leavePolicy';
import { LeaveBalanceService } from '../../services/leaveBalanceService';

/**
 * Why the "Used" figure is what it is, as tooltip text.
 *
 * The number itself is two things added together — leave applied for in the app, and leave
 * taken before the system went live, which HR recorded as a negative balance adjustment
 * because there was no request to migrate. An employee looking at "Used: 2.5" with no
 * requests to their name has no way to reach the second half, and "the system invented days"
 * is the obvious conclusion. Naming both parts is what makes the figure checkable.
 *
 * Shared rather than written at each call site so the profile drawer, Leave Assignment and
 * Reports cannot end up explaining the same number three different ways. Returns undefined
 * when there is nothing to explain (no pre-go-live days), so `title={usedTooltip(s)}` simply
 * renders no tooltip rather than an empty one.
 */
export const usedTooltip = (snapshot: LeaveBalanceSnapshot): string | undefined => {
  const historical = LeaveBalanceService.historicalUsedOf(snapshot);
  if (historical <= 0) return undefined;
  const total = LeaveBalanceService.totalUsed(snapshot);
  const parts = [`${historical} recorded by HR before go-live`];
  if (snapshot.consumed > 0) parts.push(`${snapshot.consumed} applied in the app`);
  return `${total} day(s) used — ${parts.join(', ')}`;
};
